import { Spinner } from "react-bootstrap"

function Loader() {
    return <div className="d-flex justify-content-center" >
        <Spinner animation="border" variant="secoundry" style={{ height: '21px', width: '21px' }} />
    </div>
}

export default Loader